import { render } from "./SafeDrivingSetting.vue?vue&type=template&id=2ab59c70"
import script from "./SafeDrivingSetting.vue?vue&type=script&lang=js"
export * from "./SafeDrivingSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__